import * as certifyingOfficials from './certifyingOfficials';
import * as aboutYourInstitution from './aboutYourInstitution';
import * as institutionDetails from './institutionDetails';
import * as institutionNameAndAddress from './institutionNameAndAddress';
import * as conflictOfInterestCertifyingOfficial from './conflictOfInterestCertifyingOfficial';
import * as conflictOfInterestFileNumber from './conflictOfInterestFileNumber';
import * as conflictOfInterestEnrollmentPeriod from './conflictOfInterestEnrollmentPeriod';
import * as isProprietaryProfit from './isProprietaryProfit';
import { affiliatedIndividualsSummary } from './affiliatedIndividualsSummary';
import { affiliatedIndividualsAssociation } from './affiliatedIndividualsAssociation';
import { conflictOfInterestSummary } from './conflictOfInterestSummary';

export {
  certifyingOfficials,
  aboutYourInstitution,
  institutionDetails,
  institutionNameAndAddress,
  affiliatedIndividualsSummary,
  affiliatedIndividualsAssociation,
  conflictOfInterestCertifyingOfficial,
  conflictOfInterestSummary,
  conflictOfInterestFileNumber,
  conflictOfInterestEnrollmentPeriod,
  isProprietaryProfit,
};
